import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade } from 'swiper';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/mh200/h5/');

SwiperCore.use([EffectFade]);
export default function MhEh5({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('waveportableairconditioner');

    return (
        <div className={`${css.mhEh5} mhEh5`}>
            <div className="mh-inter">
                <div className="ms-box">
                    <div className="msg-a-title1">{t('mh200.mhF1_ms1')}</div>
                    <div className="msg-a-title2">{t('mh200.mhF1_ms2')}</div>
                </div>
                <Swiper effect="fade" pagination={true} loop={true}>
                    <SwiperSlide>
                        <div className="banner-item banner-item1">
                            <EFPic className="banner-img fullImgs" name={['aniF1.webp', 'aniF1.jpg']} alt={t('mh200.mhF1_ms1')} />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="banner-item banner-item2">
                            <EFPic className="banner-img fullImgs" name={['aniF2.webp', 'aniF2.jpg']} alt={t('mh200.mhF1_ms2')} />
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    );
}
